import React, { Component } from 'react';
import { connect } from 'shalala';

import { useStore } from '../../../../store';
import Table from '../../../../facturotopia/table/Table';

import RecepcionStatusBadge from '../info/components/RecepcionStatusBadge';

class RecepcionFilesList extends Component {

  state = {};

  constructor(props) {
    super(props);

    this.state = {
      columns: this.columns,
      selected: []
    }
  }

  get columns() {
    return [
      {
        key: 'created_at',
        title: 'Fecha',
        dataIndex: 'created_at',
      },
      {
        key: 'filename',
        title: 'Archivo',
        dataIndex: 'filename',
      },
      {
        key: 'tipo',
        title: 'Tipo',
        dataIndex: 'tipo',
      },
      {
        key: 'tipo_comprobante',
        title: 'Comprobante',
        dataIndex: 'tipo_comprobante',
      },
      {
        key: 'emisor_rfc',
        title: 'Emisor',
        dataIndex: 'emisor_rfc',
      },
      {
        key: 'receptor_rfc',
        title: 'Receptor',
        dataIndex: 'receptor_rfc',
      },
      {
        key: 'cfdi_uuid',
        title: 'Folio Fiscal',
        dataIndex: 'cfdi_uuid',
      },
      {
        align: 'center',
        key: 'valid',
        title: 'Valid',
        dataIndex: 'valid',
        render: (item) => <RecepcionStatusBadge valid={ item.valid } />
      },
    ];
  }

  componentDidMount() {
    const { data } = this.props;

    if (data.length === 0) {
      this.paginate(1);
    }
  }

  paginate(meta = {}) {
    const { filters } = this.props;

    this.props.paginate({
      ...filters,
      ...meta
    });
  }

  handleOnPageChange = (page) => {
    this.paginate({ page });
  }

  handleOnPageLimitChange = (limit) => {
    this.paginate({ limit, page: 1 });
  }

  handleRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRows,
      selectedRowKeys
    }, () => {
      const { onRowSelectionChange } = this.props;

      onRowSelectionChange && onRowSelectionChange({selectedRowKeys, selectedRows});
    });
  }

  getPaginationConfig() {
    const { pagination } = this.props;

    return {
      metadata: pagination,
      onPageChange: this.handleOnPageChange,
      onPageLimitChange: this.handleOnPageLimitChange
    }
  }

  render() {
    const { columns } = this.state;
    const { data, busy } = this.props;
    const { onRowClick } = this.props;

    return (
      <Table
        loading={ busy }
        columns={ columns }
        rowKey={ 'id' }
        data={ data }
        pagination={ this.getPaginationConfig() }
        onRowClick={ onRowClick }
        onRow={ (item) => {
            return {
              className: item.highlight ? 'row-highlighted' : ''
            }
          }
        }
      >
      </Table>
    )
  }
}

const mapState = (state) => {
  return state.modulo.recepcion.list;
}

const mapActions = (actions) => {
  return {
    paginate: actions.modulo.recepcion.list.paginate
  };
}

export default connect(useStore, mapState, mapActions)(RecepcionFilesList);